import React, { useState, useEffect } from 'react';
import { VersionService } from '../services/VersionService';

function UpdateNotification() {
  const [updateInfo, setUpdateInfo] = useState(null);
  const [show, setShow] = useState(false);

  // Verifica se é app nativo (Capacitor) - notificação apenas para APK
  const isNativeApp = window?.Capacitor?.isNativePlatform?.();

  useEffect(() => {
    // Só verifica atualizações se for app nativo (não PWA)
    if (!isNativeApp) {
      return;
    }

    checkForUpdates();

    // Verifica atualizações a cada 30 minutos
    const interval = setInterval(checkForUpdates, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isNativeApp]);

  async function checkForUpdates() {
    const info = await VersionService.checkForUpdates();
    
    if (info.hasUpdate) {
      // Só mostra se ainda não notificou sobre esta versão
      if (!VersionService.wasVersionNotified(info.latestVersion)) {
        setUpdateInfo(info);
        setShow(true);
      }
    }
  }

  function handleUpdate() {
    if (updateInfo) {
      VersionService.markVersionNotified(updateInfo.latestVersion);
      VersionService.openStore();
    }
  }

  function handleDismiss() {
    if (updateInfo && !updateInfo.forceUpdate) {
      VersionService.markVersionNotified(updateInfo.latestVersion);
      setShow(false);
    }
  }

  // Não exibe notificação se não for app nativo (PWA sempre tem versão mais recente)
  if (!isNativeApp || !show || !updateInfo) return null;

  return (
    <>
      {/* Banner fixo no topo - com suporte a safe area */}
      <div style={{
        position: 'fixed',
        top: 'env(safe-area-inset-top, 0px)',
        left: 'env(safe-area-inset-left, 0px)',
        right: 'env(safe-area-inset-right, 0px)',
        background: 'linear-gradient(135deg, #22cb22 0%, #1fa81f 100%)',
        color: '#fff',
        padding: '12px 16px',
        zIndex: 99999,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        animation: 'slideDown 0.3s ease-out'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
          <span style={{ fontSize: 24 }}>🎉</span>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>
              Nova versão disponível!
            </div>
            <div style={{ fontSize: 12, opacity: 0.95 }}>
              {updateInfo.message}
            </div>
            <div style={{ fontSize: 11, opacity: 0.85, marginTop: 2 }}>
              v{updateInfo.currentVersion} → v{updateInfo.latestVersion}
            </div>
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={handleUpdate}
            style={{
              background: '#fff',
              color: '#22cb22',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            {updateInfo.forceUpdate ? 'Atualizar Agora' : 'Atualizar'}
          </button>
          
          {!updateInfo.forceUpdate && (
            <button
              onClick={handleDismiss}
              style={{
                background: 'transparent',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.5)',
                borderRadius: 8,
                padding: '8px 12px',
                fontWeight: 600,
                fontSize: 14,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
              }}
            >
              Depois
            </button>
          )}
        </div>
      </div>

      {/* Modal para atualizações obrigatórias */}
      {updateInfo.forceUpdate && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.85)',
          zIndex: 99998,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 16,
            padding: 32,
            maxWidth: 400,
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
          }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🚀</div>
            <h2 style={{ color: '#333', marginBottom: 12, fontSize: 24 }}>
              Atualização Necessária
            </h2>
            <p style={{ color: '#666', marginBottom: 24, lineHeight: 1.6 }}>
              {updateInfo.message}
            </p>
            <p style={{ color: '#999', fontSize: 13, marginBottom: 24 }}>
              Versão atual: {updateInfo.currentVersion}<br />
              Nova versão: {updateInfo.latestVersion}
            </p>
            <button
              onClick={handleUpdate}
              style={{
                background: 'linear-gradient(135deg, #22cb22 0%, #1fa81f 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                padding: '14px 32px',
                fontWeight: 700,
                fontSize: 16,
                cursor: 'pointer',
                width: '100%',
                boxShadow: '0 4px 12px rgba(34, 203, 34, 0.3)'
              }}
            >
              Atualizar Agora
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
}

export default UpdateNotification;
